"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Spinner = _interopRequireDefault(require("@cimpress/react-components/lib/shapes/Spinner"));

var Loading = function Loading(_ref) {
  var text = _ref.text;
  return _react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, _react["default"].createElement(_Spinner["default"], null), text && _react["default"].createElement("h5", null, text));
};

var _default = Loading;
exports["default"] = _default;